// extracted by mini-css-extract-plugin
module.exports = {"c-icon":"icon_c-icon__qwUt3"};